<template>
    <div class="report">
        <div class="report__container color_gray_800">
            <div class="b3 line_height_32">
                <div class="pd_all_60">
                    <!-- <div>{{ globalStore.userInfo.schoolName }} {{ getStringUserGrade }}</div> -->
                    <!-- 학교학년 -->
                    <div>{{ comSchoolAndGrade }}</div>
                    <div class="report__title">
                        <!-- <b>{{ globalStore.userInfo.studentName }}님의 독해력은 </b> -->
                        <!-- 이름 -->
                        <b>{{ comUserName }}님의 독해력은 </b>
                        <span style="color: #18b73f; font-weight: bold">
                            {{ summaryData?.totalAccuracyRate > 80 ? '우수한' : summaryData?.totalAccuracyRate > 50 ? '평균' : '낮은' }}
                            수준</span
                        >
                        <b>입니다.</b>
                    </div>
                    <div class="report__calendar"><q-icon name="img:/assets/images/icon/ico_report_calender.svg" style="width: 2.1vw; height: 2.1vw" /> {{ summaryData?.issueDate }}</div>
                </div>
                <div class="chart__wrap">
                    <div style="width: 38.33vmin; height: 19vmin">
                        <!-- <div style="width: 306px;height: 120px ;"> -->
                        <GaugeChart v-if="summaryData?.totalAccuracyRate" :chartData="summaryData?.totalAccuracyRate" header="독해력" />
                    </div>
                </div>
                <div class="pd_all_60">
                    <div v-if="summaryData" class="item-box">
                        <div class="item-box__item">
                            <div>코어독해</div>
                            <div class="item-box__num">{{ summaryData.coreResult }}%</div>
                        </div>
                        <q-linear-progress rounded size="1.33vmin" :value="summaryData.coreResult / 100" color="primary" />
                        <div class="item-box__item mg_top_52">
                            <div>본격독해</div>
                            <div class="item-box__num">{{ summaryData.earnestResult }}%</div>
                        </div>
                        <q-linear-progress rounded size="1.33vmin" :value="summaryData.earnestResult / 100" color="primary" />
                        <div class="item-box__item mg_top_52">
                            <div>어휘학습</div>
                            <div class="item-box__num">{{ summaryData.vocabularyResult }}%</div>
                        </div>
                        <div style="display: flex; align-items: center">
                            <q-linear-progress rounded size="1.33vmin" :value="summaryData.vocabularyResult / 100" color="primary" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: calc(100% - 48.33vmin); height: calc(100vh - 7.9vmin)">
            <q-scroll-area ref="scrollAreaRef" visible style="height: 100%; padding: 0px 10px">
                <div class="scroll__pd">
                    <div class="title">{{ summaryData?.area }} 학습 분석 결과</div>
                    <div class="row" style="width: 100%">
                        <div class="col-6">
                            <div>
                                <span class="h4 bold line_height_38">사고 유형별 강약점</span>
                                <Help class="question-mark">
                                    <div class="pd_left_20">
                                        <ul class="mark__list">
                                            <li style="list-style: disc">사실적독해 : 글에 표면적으로 드러난 정보를 파악하여 글의 내용을 체계적으로 이해하는 능력</li>
                                            <li style="list-style: disc">추론적독해 : 생략된 정보를 추론하고, 글에 드러난 단서를 근거로 글쓴이의 의도나 목적을 추측하는 능력</li>
                                            <li style="list-style: disc">비판적독해 : 글에 사용된 자료가 정확한지, 글쓴이의 주장이나 의견이 타당한지 점검하며 글을 읽는 능력</li>
                                            <li style="list-style: disc">감상적독해 : 글에서 공감하거나 감동적인 부분을 읽고 글에 담긴 가치를 종합적으로 이해하는 능력</li>
                                            <li style="list-style: disc">개념 : 개념을 적용하여 글을 이해하고 판단하는 능력</li>
                                            <li style="list-style: disc">어휘 : 글에 나온 어휘의 의미를 알고 문맥에 맞게 사용하며 적용할 수 있는 능력</li>
                                        </ul>
                                    </div>
                                </Help>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mg_bottom_16" style="margin-left: 0.83vmin">
                                <span class="h4 bold line_height_38">질문 유형별 강약점</span>
                            </div>
                        </div>
                    </div>
                    <div class="summary_box__wrap">
                        <div class="summary_box">
                            <div class="result">
                                <q-chip class="result_chip">우수</q-chip>
                                <span>
                                    {{ analysisResult?.analysisType?.strong ? analysisResult?.analysisType?.strong : '우수한 유형이 없어요.' }}
                                </span>
                            </div>
                            <div class="result mg_top_40"><q-chip class="result_chip">취약</q-chip> {{ analysisResult?.analysisType?.week ? analysisResult?.analysisType?.week : '취약한 유형이 없어요.' }}</div>
                        </div>

                        <div class="summary_box">
                            <div class="result"><q-chip class="result_chip">우수</q-chip>{{ analysisResult?.problemType?.strong ? analysisResult?.problemType?.strong : '우수한 유형이 없어요.' }}</div>
                            <div class="result mg_top_40"><q-chip class="result_chip">취약</q-chip> {{ analysisResult?.problemType?.week ? analysisResult?.problemType?.week : '취약한 유형이 없어요.' }}</div>
                        </div>
                    </div>
                    <div class="final__comment bold" style="padding: 20px; font-size: 2.3vmin; line-height: 4.16vmin; white-space: pre-line" v-html="analysisResult?.finalComment"></div>
                    <!-- <div style="padding: 20px; font-size: 18px; line-height: 30px;">
                  지문 읽기 활동에서 <b>(4. '윤리의 이해' 지문 읽기 시간은 권장 읽기 시간을 초과하였습니다. 지문을 집중하면서 읽으면서 시간을 단축시키는 연습이 필요합니다. 지문을 여러 번
                    읽으며 처음 지문 읽을 때 걸린 시간과
                    다회독 때 읽은 시간을 비교해 보면서 지문 읽기 시간을 줄이는 훈련을 해 보세요.)</b><br />
                  지문 이해 활동을 살펴보면, <b>(5. 핵심 소재를 파악하는 능력은 갖추었으나, 주제를 찾고 핵심 표현을 정리하는 훈련이 필요합니다. 주제를 잘 파악하기 위해서는 중심 내용을
                    구조화하여 단락별 핵심내용을 찾는 연습을
                    꾸준히 해 보세요.)</b><br />
                  본격독해에서 풀이한 문항 유형별 문제 해결력을 살펴보면, <b>(6. 사실적 독해, 비판적독해, &lt;보기&gt;가 없는 문항) 유형의 문제 해결력은 우수하나, (7. 글 부분에 대한
                    이해, 부정형질문) 유형에 약합니다. 반복해서
                    틀리는 문제의 유형을 명확히 파악하고, 유사한 형태의 문제를 매일 일정량 훈련하면 문제 해결력을 향상시킬 수 있습니다.</b>
                </div> -->
                    <br />
                    <div class="title">학습 상세 내역</div>
                    <div style="margin-bottom: 10px">
                        <q-tabs v-model="tab" class="tab-passage">
                            <q-tab name="passage1" label="지문1" />
                            <q-tab name="passage2" label="지문2" />
                        </q-tabs>
                        <!-- <q-btn-toggle v-model="model" spread no-caps rounded unelevated toggle-color="primary" color="white"
                  text-color="black" style="border:2px solid #18b73f;" :options="[
                    { label: '지문1-인문', value: '1' },
                    { label: '지문2-정치 사회', value: '2' }
                  ]" /> -->
                    </div>
                    <q-tab-panels v-model="tab">
                        <q-tab-panel v-for="(item, index) in passageList" :name="'passage' + (index + 1)">
                            <div class="passage">
                                <div class="passage__topic">
                                    {{ item?.topic }}
                                </div>
                                <div class="passage__header">
                                    <div class="passage__name">{{ item.passageName }}</div>
                                    <div class="passage__info">
                                        <div v-if="item && item?.kreadScore && item?.kreadScore !== ''" class="kread">
                                            <img src="@/assets/images/main/kread.svg" />
                                            <div class="score">
                                                {{ item?.kreadScore }}
                                            </div>
                                        </div>
                                        <div class="kread">
                                            <div class="b3 bold">성취율 {{ item.accuracyRate }}%</div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div class="conner_info">
                                    <div class="h3 bold">코어독해</div>
                                    <div class="b2 regular color_gray_600">
                                        <div v-if="item?.coreElapsedTime">학습 시간 : {{ getTimeStringSecondsKor(item?.coreElapsedTime) }}</div>
                                    </div>
                                </div>
                                <div class="sub-title">⦁ 지문 읽기 활동</div>
                                <q-markup-table flat class="summary-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center">나의 읽기 시간</th>
                                            <th class="text-center">결과</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-center">
                                                <div>
                                                    <b>{{ getTimeStringSecondsKor(item.coreResult.readingResult.passageReadTime) }}</b>
                                                    <div>권장 읽기 시간: {{ getTimeStringSecondsKor(item.coreResult.readingResult.solveTime) }}</div>
                                                </div>
                                            </td>
                                            <td class="text-center">
                                                <span :style="getReadTimeMsg(item.coreResult.readingResult) !== '시간 준수' ? 'color:#EF2B2A;font-weight: bold;' : 'font-weight: bold;'">
                                                    {{ getReadTimeMsg(item.coreResult.readingResult) }}
                                                </span>
                                                <!-- <span
                          :style="(((item.coreResult.readingResult.passageReadTime) > item.coreResult.readingResult.solveTime) || (item.coreResult.readingResult.etcCd02 !== '05' && item.coreResult.readingResult.passageReadTime < 30)) ? 'color:#EF2B2A;font-weight: bold;' : 'font-weight: bold;'">
                          {{ ((item.coreResult.readingResult.passageReadTime) < 30 &&
                              item.coreResult.readingResult.etcCd02 !== '05') ? '주의' :
                              (item.coreResult.readingResult.passageReadTime) >
                                item.coreResult.readingResult.solveTime ? '시간 초과' :
                                '시간 준수'
                          }}
                        </span> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </q-markup-table>
                                <br />
                                <div class="mg_top_40 sub-title">⦁ 지문 이해 활동</div>
                                <q-markup-table flat class="summary-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center">내용</th>
                                            <th class="text-center" style="width: 80px">정답여부</th>
                                            <th class="text-center" style="width: 80px">풀이화면</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="tData in item.coreResult?.understandingResult">
                                            <td class="text-left">
                                                {{ tData.content }}
                                            </td>
                                            <td class="text-center">
                                                {{ tData.content.indexOf('구조화') !== -1 ? '완료' : '' }}
                                                <!-- <q-icon v-if="tData.content.indexOf('구조화') === -1"
                              :name="tData.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm"
                              :style="tData.correctYn === false ? 'color:#FD6956 ;' : ''">
                            </q-icon> -->
                                                <q-icon class="b3" v-if="tData.content.indexOf('구조화') === -1" :name="'img:/assets/images/icon/ic_ox_' + tData.correctCode + '.svg'" style="width: 2vw; height: 2vw"></q-icon>
                                            </td>
                                            <td
                                                class="text-center"
                                                style="cursor: pointer"
                                                :onClick="
                                                    () => {
                                                        onClickReview('core', tData?.answerHistorySeq);
                                                    }
                                                "
                                            >
                                                <u>보기</u>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="text-left">작품 해설 강의 영상 보기</td>
                                            <td class="text-center">완료</td>
                                            <td class="text-center">
                                                <q-icon
                                                    v-if="item.coreResult?.videoUrl"
                                                    name="img:/assets/images/icon/ico_video.svg"
                                                    style="width: 2vw; height: 2vw; cursor: pointer"
                                                    :onClick="
                                                        () => {
                                                            onClickVideo(item.coreResult?.videoUrl);
                                                        }
                                                    "
                                                ></q-icon>
                                                <!-- <u v-if="item.coreResult?.videoUrl" style="cursor: pointer" :onClick="onClickVideo">보기</u> -->
                                                <span v-if="!item.coreResult?.videoUrl">-</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </q-markup-table>
                                <br />
                                <div class="conner_info">
                                    <div class="h3 bold">본격독해</div>
                                    <div class="b2 regular color_gray_600">
                                        <div>학습 시간 : {{ getTimeStringSecondsKor(item?.earnestElapsedTime) }}</div>
                                    </div>
                                </div>
                                <q-markup-table flat class="summary-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center">유형</th>
                                            <th class="text-center">학습 개념 상세</th>
                                            <th class="text-center" style="width: 80px">문항난이도</th>
                                            <th class="text-center" style="width: 80px">정답여부</th>
                                            <th class="text-center" style="width: 80px">풀이화면</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="vData in Object.values(item.earnestResultList)">
                                            <tr v-for="(tItems, index) in vData">
                                                <td v-if="index === 0" class="text-left" :rowspan="vData.length">
                                                    {{ tItems.analysisName }}
                                                </td>
                                                <td class="text-left">
                                                    <div class="problem__class b3 color_gray_600">
                                                        {{ tItems.problemClassCode === '1' ? '기준문제' : '드릴문제' }}
                                                        <q-icon v-if="tItems.important === 'Y'" class="important" :name="'img:/assets/images/icon/ic_important.svg'"></q-icon>
                                                    </div>
                                                    <div>{{ tItems.learningConceptDetailName }}</div>
                                                </td>
                                                <td class="text-center">
                                                    <q-chip class="caption2 medium" :style="tItems.difficultCode === '04' ? 'background-color:#D8F6FF;' : tItems.difficultCode === '05' ? 'background-color:#FFD8D8 ;' : 'background-color:#E8DFFF;'">
                                                        {{ difficult[tItems.difficultCode]?.label }}
                                                    </q-chip>
                                                </td>
                                                <td class="text-center">
                                                    <!-- <q-icon :name="tItems.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm"
                                :style="tItems.correctYn === false ? 'color:#FD6956 ;' : ''"> -->
                                                    <q-icon class="b3" :name="'img:/assets/images/icon/ic_ox_' + tItems.correctCode + '.svg'" style="width: 2vw; height: 2vw"> </q-icon>
                                                </td>
                                                <td
                                                    class="text-center"
                                                    style="cursor: pointer"
                                                    :onClick="
                                                        () => {
                                                            onClickReview('earnest', tItems?.answerHistorySeq);
                                                        }
                                                    "
                                                >
                                                    <u>보기</u>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </q-markup-table>
                                <br />
                                <div class="conner_info">
                                    <div class="h3 bold">어휘학습</div>
                                    <div class="b2 regular color_gray_600">
                                        <div>학습 시간 : {{ getTimeStringSecondsKor(item.vocabularyElapsedTime) }}</div>
                                    </div>
                                </div>
                                <q-markup-table flat class="summary-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center">내용</th>
                                            <th class="text-center" style="width: 80px">정답여부</th>
                                            <th class="text-center" style="width: 80px">풀이화면</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tData, index) in item?.vocabularyResultList">
                                            <td class="text-left">
                                                {{ tData.content }}
                                            </td>
                                            <td class="text-center">
                                                <!-- <q-icon :name="tData.correctYn === true ? 'radio_button_unchecked' : 'close'" size="sm"
                              :style="tData.correctYn === false ? 'color:#FD6956 ;' : ''">
                            </q-icon> -->
                                                <q-icon class="b3" :name="'img:/assets/images/icon/ic_ox_' + tData.correctCode + '.svg'" style="width: 2vw; height: 2vw"> </q-icon>
                                            </td>
                                            <td
                                                class="text-center"
                                                style="cursor: pointer"
                                                :onClick="
                                                    () => {
                                                        onClickReview('vocabulary', tData?.answerHistorySeq, index + 1);
                                                    }
                                                "
                                            >
                                                <u>보기</u>
                                            </td>
                                        </tr>
                                    </tbody>
                                </q-markup-table>
                            </div>
                        </q-tab-panel>
                    </q-tab-panels>
                    <div style="text-align: center; margin-bottom: 10px" class="btn__wrap">
                        <template v-if="!isListItem">
                            <template v-if="globalStore.loginRoot === 'growthplate'">
                                <CqBtn class="btn" outline color="" label="다음 과목 선택" style="margin-right: 10px" @onClickFn="moveToGrowthplate('end')" />
                            </template>
                            <CqBtn class="btn" outline color="" label="다음 학습" @onClickFn="studyStart" style="margin-right: 10px" />
                            <CqBtn class="btn" outline color="" label="학습 홈" @onClickFn="movePg('learninghome')" style="margin-left: 10px" />
                            <template v-if="globalStore.loginRoot === 'growthplate'">
                                <CqBtn class="btn" outline color="" label="오늘 학습 종료" style="margin-left: 10px" @onClickFn="moveToGrowthplate('selfcheck')" />
                            </template>
                        </template>
                        <template v-if="isListItem">
                            <CusButton
                                :type="462"
                                :label="`분석리포트 홈`"
                                @onReturn="
                                    () => {
                                        emit('close');
                                    }
                                "
                            />
                            <!-- <CqBtn class="btn" outline color="" label="분석리포트 홈" @onClickFn="() => { emit('close'); }" /> -->
                        </template>
                    </div>
                </div>
            </q-scroll-area>
            <!-- <qbankHeaderVue :v-if="questionHeader" :questionHeader="questionHeader" /> -->
        </div>
    </div>

    <q-dialog v-model="videoStudy" maximized>
        <div v-if="videoStudy" style="width: 90%; height: 80%">
            <VideoTest :videoSrc="videoUrl" :isDone="true" />
        </div>
    </q-dialog>

    <q-dialog v-model="reviewModal" persistent maximized>
        <!-- transition-show="slide-left" transition-hide="slide-right"
  > -->
        <Review v-if="review === 'earnest' && reviewModal" :answerHistorySeq="answerHistorySeq"></Review>
        <ReviewCore v-if="review === 'core' && reviewModal" :answerHistorySeq="answerHistorySeq"></ReviewCore>
        <ReviewVoca v-if="review === 'vocabulary' && reviewModal" :num="reviewNum" :answerHistorySeq="answerHistorySeq"> </ReviewVoca>
    </q-dialog>
</template>

<script setup>
import CusButton from '@/components/widget/CusButton.vue';
import GaugeChart from '@/components/chart/gaugeChart.vue';
import { onMounted, ref, watc, computed } from 'vue';
import { getUserJson, getUserMain, postUserJson, growthplateFinish, logoutApi } from '@/api/modules/login';
import * as zzApi from '@/api/modules/login';
import { GlobalStore } from '@/store';
import _ from 'lodash';
import { StudyStore } from '@/store/modules/study';
import { getTimeStringSecondsKor, replaceQuotes, timeStringSecondsKorToSec } from '@/helpers/utils';
import { useRouter } from 'vue-router';
import CqBtn from '@/components/quasar/cqBtn.vue';
import { analysisOrd, difficult, learningType } from '@/helpers/qbankParser/qbankMeta';
import moment from 'moment';
import { useQuasar } from 'quasar';
import Help from '@/components/quasar/help.vue';
import Review from '../component/review.vue';
import ReviewCore from '../component/reviewCore.vue';
import ReviewVoca from '../component/reviewVoca.vue';

import Comm from '@/components/common.js';
import VideoTest from '@/components/qbank/VideoTest.vue';
// import { requestGrowthplateLogout } from '@/helpers/common';

const videoStudy = ref(false);
const videoUrl = ref('');

const $q = useQuasar();
const coreProcess = ref(0.5);
const model = ref('1');
const user = ref(null);
const reviewModal = ref(false);
const review = ref('earnest');
const reviewNum = ref('1');
const answerHistorySeq = ref(null);
const tab = ref('passage1');
const globalStore = GlobalStore();
const studyStore = StudyStore();
const summaryData = ref(null);
const passageList = ref([]);
const analysisResult = ref({});
const router = useRouter();

const comUserName = computed(() => {
    return Comm.getStrName();
});
const comSchoolAndGrade = computed(() => {
    return Comm.getStrSchoolAndGrade();
});

const props = defineProps({
    reportData: {
        default: null,
    },
    isListItem: { default: false },
});

const emit = defineEmits(['close']);

const growthData = ref({
    systemId: '',
    sbjgrpId: '',
    sbjgrpSeq: '',
    kunnr: '',
    loginSeq: '',
    scenarioSeq: '',
    accessToken: '',
    scenarioLvlSeq: '',
    ustudyActSeq: '',
    zempId: '',
    matnrSeq: '',
    matnr: '',
    zProc: '',
    setNo: '',
});

const onClickReview = (type, seq, num = 1) => {
    // console.log(seq);
    review.value = type;
    answerHistorySeq.value = seq;
    reviewModal.value = true;
    reviewNum.value = num;
    // getReportReview({ answerHistorySeq: seq }, (rs) => {
    //   console.log(rs);
    // })
};
const onClickVideo = (url) => {
    // console.log('-----------> videourl : ' + url);
    // const testUrl = 'https://d-ds-asset.daekyo.com/bank/object/KRT_01_17_N_033_C.mp4';
    // console.log('--onClickVideo-passageList.value -', passageList.value);
    // console.log('--onClickVideo-passageList.value[0]?.coreResult?.videoUrl-', passageList.value[0]?.coreResult?.videoUrl);
    videoUrl.value = process.env.VUE_APP_DS_QBANK_ASSET_URL + url;
    // console.log('--onClickVideo', videoUrl.value);
    videoStudy.value = true;
    // console.log('--onClickVideo-testUrl-', testUrl);
};

const getReadTimeMsg = (item) => {
    if (item.passageReadTime > item.solveTime) {
        return '시간 초과';
    } else if (item.passageReadTime < 30) {
        return '주의';
    } else {
        return '시간 준수';
    }
};

const requestGrowthplateFinish = async () => {
    console.log('studyStore ===', studyStore);
    let params = {
        learningHistorySeqs: studyStore?.report?.learningHistorySeqs?.split(','),
        learningTypeCode: learningType[studyStore.process.exam.learningType].code,
    };
    console.log('requestGrowthplateFinish params ===', params);

    const response = await growthplateFinish(params);
    console.log('growthplateFinish API response ===', response);
    const resData = response?.data?.data;
    if (response?.data?.statusCode === '200') {
        growthData.value.systemId = resData?.systemId;
        growthData.value.sbjgrpId = resData?.sbjgrpId;
        growthData.value.sbjgrpSeq = resData?.sbjgrpSeq;
        growthData.value.kunnr = resData?.kunnr;
        growthData.value.loginSeq = resData?.loginSeq;
        growthData.value.scenarioSeq = resData?.scenarioSeq;
        growthData.value.accessToken = resData?.accessToken;
        growthData.value.scenarioLvlSeq = resData?.scenarioLvlSeq;
        growthData.value.ustudyActSeq = resData?.ustudyActSeq;
        growthData.value.zempId = resData?.zempId;
        growthData.value.matnrSeq = resData?.matnrSeq;
        growthData.value.matnr = resData?.matnr;
        growthData.value.zProc = resData?.zProc;
        growthData.value.setNo = resData?.setNo;
    }
};

const sendGrowthData = (type) => {
    const globalStore = GlobalStore();
    let dataToSend = {
        systemId: growthData.value.systemId,
        sbjgrpId: growthData.value.sbjgrpId,
        sbjgrpSeq: growthData.value.sbjgrpSeq,
        kunnr: encodeURI(growthData.value.kunnr),
        loginSeq: growthData.value.loginSeq,
        scenarioSeq: growthData.value.scenarioSeq,
        accessToken: encodeURI(growthData.value.accessToken),
        scenarioLvlSeq: growthData.value.scenarioLvlSeq,
        ustudyActSeq: growthData.value.ustudyActSeq,
        zempId: encodeURI(growthData.value.zempId),
        matnrSeq: growthData.value.matnrSeq,
        matnr: growthData.value.matnr,
        zProc: growthData.value.zProc,
        setNo: growthData.value.setNo,
        path: type === 'selfcheck' ? 'Important' : 'Main',
    };
    // const jsonStr = JSON.stringify(dataToSend);
    // console.log('jsonStr ===', jsonStr);
    //Growth.sendDataToAndroid(jsonStr);
    window.PanApp.sendErrToAndroid('Home');

    globalStore.setToken(null);
    globalStore.setReToken(null);
    globalStore.setAudience('');
    globalStore.setLogoutPath('');
};

const moveToGrowthplate = (type) => {
    console.log('moveToGrowthplate type ===', type);
    sendGrowthData(type);
};

onMounted(() => {
    if (props.reportData) {
        passageList.value = [];
        const dataSet = (rs) => {
            summaryData.value = {
                totalAccuracyRate: rs.totalAccuracyRate,
                coreResult: rs.totalLearningResult.coreResult,
                earnestResult: rs.totalLearningResult.earnestResult,
                vocabularyResult: rs.totalLearningResult.vocabularyResult,
                issueDate: rs.issueDate,
                area: rs.areaCode === '02' ? '비문학' : '문학',
            };
            analysisResult.value = rs.analysisResult;

            // finalComment에 따옴표 형태를 치환
            analysisResult.value.finalComment = analysisResult.value.finalComment && replaceQuotes(analysisResult.value.finalComment);

            // 본격독해 그리기 위한 데이터 변경
            rs.passageList.forEach((ei) => {
                let tmpItems = ei;
                let tmpEarnestResultList = {};
                ei.earnestResultList.forEach((eii) => {
                    let temp = tmpEarnestResultList[analysisOrd[eii.analysisId]] ? tmpEarnestResultList[analysisOrd[eii.analysisId]] : [];
                    temp = [...temp, eii];
                    tmpEarnestResultList = { ...tmpEarnestResultList, [analysisOrd[eii.analysisId]]: temp };
                });
                tmpItems = { ...tmpItems, earnestResultList: tmpEarnestResultList };
                passageList.value = [...passageList.value, tmpItems];
            });
            // console.log(passageList.value);
        };

        dataSet(props.reportData);

        // console.log(_.isEmpty(globalStore.userInfo));
        if (_.isEmpty(globalStore.userInfo)) {
            globalStore.getUserInfo();
            // console.log(globalStore.getUserInfo());
        }
        user.value = globalStore.userInfo;
    }

    // if (!props.isListItem && globalStore.loginRoot === 'growthplate') {
    //     requestGrowthplateFinish();
    // }
});

const movePg = (pg) => {
    router.push('/' + pg);
};

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
};

const studyStart = async () => {
    /* KRT-1587 */
    const res = await zzApi.getUserMain2();
    if (res && res.status === 200) {
        const rs = res.data.data;
        let tmpMapTree = [];
        // let tmpStudy = { '01': [], '02': [] };
        rs.studyMain.forEach((element) => {
            // tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
            tmpMapTree.push({
                // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
                examCode: element.examName,
                version: rs.exprVersion,
                // TODO: 변경해야함
                headerEtcCd02: element.areaCode === '01' ? '05' : '02',
                headerEtcCd01: element.passageClass,
                passageClass: element.passageClass,
                area: element.areaCode === '01' ? '문학' : '비문학',
                title: element.passageName,
                areaCode: element.areaCode,
                isDone: false,
                learningStatus: element.learningStatus,
                learningType: element.learningType,
                difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
                satOrder: element?.satOrder ? element?.satOrder : null,
                groupIndex: element?.groupIndex ? element?.groupIndex : null,
                level: element?.level,
                lesson: element?.lesson,
            });
        });
        studyStore.level = rs.level;
        studyStore.lesson = rs.lesson;
        studyStore.exprVersion = rs.exprVersion;
        studyStore.mapTree.exams = tmpMapTree;
        // studyStore.difficultyL = JSON.parse(rs.difficultyL);
        // studyStore.difficultyN = JSON.parse(rs.difficultyN);

        const fIndex = _.findIndex(rs.studyMain, function (o) {
            return o.examName === rs.currentStart.examName;
        });
        studyStore.process.examIdx = fIndex;
        if (rs.studyMain[fIndex].learningStatus === 'W') {
            studyStore.process.studyTree = 5082;
        }
        studyStore.process.problemOrd = 0;
        studyStore.process.exam = {
            // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
            examCode: rs.currentStart.examName,
            version: rs.exprVersion,
            // TODO: 변경해야함
            headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
            headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
            passageClass: rs.studyMain[fIndex].passageClass,
            area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
            title: rs.studyMain[fIndex].passageName,
            areaCode: rs.currentStart.areaCode,
            isDone: false,
            learningHistorySeq: rs.currentStart.learningHistorySeq,
            learningType: rs.currentStart.learningType,
            learningStatus: rs.studyMain[fIndex]?.learningStatus,
            difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
            satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
            groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
            level: rs.currentStart?.level,
            lesson: rs.currentStart?.lesson,
        };

        // postUserJson(JSON.stringify(studyStore.process), (rs) => {
        //   //
        // });

        if (rs.currentStart.learningType === 'SAT' || rs.currentStart.learningType === 'SAT_RESET') {
            return router.push('/sat');
        } else {
            return router.push('/corereading');
        }
    }

    // getUserMain((rs) => {
    //     let tmpMapTree = [];
    //     // let tmpStudy = { '01': [], '02': [] };
    //     rs.studyMain.forEach((element) => {
    //         // tmpStudy[element.areaCode] = [...tmpStudy[element.areaCode], element];
    //         tmpMapTree.push({
    //             // examCode: element.learningType !== 'SAT' ? element.examName.slice(0, element.examName.length - 2) : element.examName,
    //             examCode: element.examName,
    //             version: rs.exprVersion,
    //             // TODO: 변경해야함
    //             headerEtcCd02: element.areaCode === '01' ? '05' : '02',
    //             headerEtcCd01: element.passageClass,
    //             passageClass: element.passageClass,
    //             area: element.areaCode === '01' ? '문학' : '비문학',
    //             title: element.passageName,
    //             areaCode: element.areaCode,
    //             isDone: false,
    //             learningStatus: element.learningStatus,
    //             learningType: element.learningType,
    //             difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
    //             satOrder: element?.satOrder ? element?.satOrder : null,
    //             groupIndex: element?.groupIndex ? element?.groupIndex : null,
    //             level: element?.level,
    //             lesson: element?.lesson,
    //         });
    //     });
    //     studyStore.level = rs.level;
    //     studyStore.lesson = rs.lesson;
    //     studyStore.exprVersion = rs.exprVersion;
    //     studyStore.mapTree.exams = tmpMapTree;
    //     // studyStore.difficultyL = JSON.parse(rs.difficultyL);
    //     // studyStore.difficultyN = JSON.parse(rs.difficultyN);

    //     const fIndex = _.findIndex(rs.studyMain, function (o) {
    //         return o.examName === rs.currentStart.examName;
    //     });
    //     studyStore.process.examIdx = fIndex;
    //     if (rs.studyMain[fIndex].learningStatus === 'W') {
    //         studyStore.process.studyTree = 5082;
    //     }
    //     studyStore.process.problemOrd = 0;
    //     studyStore.process.exam = {
    //         // examCode: rs.currentStart.learningType !== 'SAT' ? rs.currentStart.examName.slice(0, rs.currentStart.examName.length - 2) : rs.currentStart.examName,
    //         examCode: rs.currentStart.examName,
    //         version: rs.exprVersion,
    //         // TODO: 변경해야함
    //         headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
    //         headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
    //         passageClass: rs.studyMain[fIndex].passageClass,
    //         area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
    //         title: rs.studyMain[fIndex].passageName,
    //         areaCode: rs.currentStart.areaCode,
    //         isDone: false,
    //         learningType: rs.currentStart.learningType,
    //         learningStatus: rs.studyMain[fIndex]?.learningStatus,
    //         difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
    //         satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
    //         groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
    //         level: rs.currentStart?.level,
    //         lesson: rs.currentStart?.lesson,
    //     };

    //     // postUserJson(JSON.stringify(studyStore.process), (rs) => {
    //     //   //
    //     // });

    //     if (rs.currentStart.learningType === 'SAT' || rs.currentStart.learningType === 'SAT_RESET') {
    //         return router.push('/sat');
    //     } else {
    //         return router.push('/corereading');
    //     }
    // });

    // if (studyStore.process.exam.learningType === 'SAT') {
    //   router.push('/sat');
    // } else {
    //   router.push(studyStore.process.studyTree === 5083 ? '/authenticreading' : studyStore.process.studyTree === 5084 ? '/vocabularylearning' : 'corereading');
    // }
};
</script>

<style scoped lang="scss">
.report {
    display: flex;
    width: 100%;

    // height: calc(100vh - 7.17vmin);
    height: 100%;

    &__container {
        width: 48.33vmin;
        min-width: 300px;
        height: 100%;
        background-color: $color_gray_200;
        height: calc(100vh - 7.9vmin);
    }

    &__title {
        font-weight: 700;
        font-size: 2.2vw;
        line-height: 3.3vw;
    }

    &__calendar {
        margin-top: 2.67vmin;
        display: flex;
        line-height: 1.6vw;
        font-size: 1.2vw;
        align-items: center;
        color: $color_gray_600;
    }

    .chart__wrap {
        display: flex;
        justify-content: center;
    }

    .pd_all_60 {
        padding: 5vmin;
    }
}

.sub-title {
    margin-bottom: 0.67vmin;
    font-size: 1.4vw;
    font-weight: bold;
    line-height: 2.25vw;
}

.title {
    font-size: 1.8vw;
    font-weight: 700;
    line-height: 2.6vw;
    margin-bottom: 3vmin;
}

.scroll__pd {
    padding: 5vmin;
}

.summary_box__wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.summary_box {
    display: grid;
    // display: flex;
    width: calc(50% - 0.83vmin);
    padding: 1.67vmin 2.66vmin;
    border: 1px solid #e0e0e0;
    // border-radius: 10px;
    @include border-radius(0.8vw);
    // background-color: #F6F6F6;
    font-size: 1.2vw;
    font-weight: 500;
    line-height: 1.6vw;

    .result {
        display: flex;
        align-items: center;

        .result_chip {
            height: 2.2vw;
            margin-right: 2.33vmin;
            padding: 0.83vmin 1.33vmin;
            @include border-radius(1.1vw);
            font-size: 1vw;
            line-height: 1.2vw;
        }
    }
}

.final__comment {
    padding: 1.67vmin;
    font-size: 1.4vw;
    line-height: 2.5vw;
    white-space: pre-line;
    margin-bottom: 6.67vmin;
}

.summary-table {
    border-top: 1px solid #8e8e8e;
    border-bottom: 1px solid #8e8e8e;
    border-radius: 0px;

    thead {
        background-color: #ededed;
    }
}

.item-box {
    // display: flex;
    // border: 1px solid #E0E0E0;
    // border-radius: 10px;
    // padding: 20px;
    padding: 4vmin 3.33vmin;
    border: 1px solid $color_gray_400;
    // border-radius: 1.33vmin;
    @include border-radius(0.8vw);
    background-color: $color_white;
    // font-size: 2vmin;
    font-size: 1.1vw;
    font-weight: 500;
    line-height: 1.4vw;

    .item-box__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1vmin;
    }

    .item-box__num {
        color: #18b73f;
        font-weight: 700;
        font-size: 1.5vw;
        line-height: 1.9vw;
    }
}

.tab-passage {
    height: 8.17vmin;

    .q-tab {
        width: 50%;
    }

    ::v-deep .q-tab__label {
        font-size: 2.33vmin;
        color: #18b73f;
    }

    .q-tab--active {
        border: 2px solid $color_primary;
        border-bottom: 0;
        @include border-radius(0.8vw 0.8vw 0 0);
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
        // border-top: 2px solid #18b73f;
        // border-left: 2px solid #18b73f;
        // border-right: 2px solid #18b73f;
        border-bottom: none;
    }

    ::v-deep .q-tab__indicator {
        display: none !important;
    }

    ::v-deep .q-tab--inactive {
        border-bottom: 2px solid #18b73f;

        .q-tab__label {
            color: #bdbdbd;
            font-size: 2.33vmin;
        }
    }
}

.passage {
    padding: 1.67vmin;

    &__topic {
        margin-bottom: 0.75vmin;
        font-size: 1.3vw;
        line-height: 2.1vw;
        font-weight: 500;
        color: $color_gray_600;
    }

    &__header {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: space-between;
    }

    &__name {
        font-size: 2vw;
        font-weight: 700;
        line-height: 2.6vw;
    }

    &__info {
        display: flex;
        position: relative;
        align-items: center;

        .kread {
            display: inline-flex;
            background-color: #efefef;
            font-size: 1.1vw;
            align-items: center;
            border-radius: 60px;
            padding: 0 2.66vmin;
            height: 6.67vmin;
            margin-left: 1.33vmin;

            img {
                height: 2vmin;
                margin-right: 8px;
            }

            .score {
                background-color: $primary;
                padding: 0.17vmin 0.83vmin;
                border-radius: 50%;
                color: white;
                font-weight: 700;
            }
        }
    }
}

.conner_info {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3.33vmin;
    margin-top: 6.67vmin;
}

.q-table {
    font-size: 2vmin;

    th {
        background-color: $color_gray_100;
        font-size: 1.2vw;
        // padding: 2.3vmin 0 2vmin;
        height: 6.67vmin;
    }

    td {
        font-size: 1.3vw;
        line-height: 2.1vw;
        font-weight: 400;
        height: 8.5vmin;
        white-space: normal;
    }
}

::v-deep {
    .passage .q-chip {
        // display: inline-block;
        height: 2.3vw;
        padding: 0.83vmin 1.33vmin;
        @include border-radius(1.1vw);
        font-size: 1vw;
        font-weight: 500;
        line-height: 1.3vw;
    }
    .q-chip__content {
        font-weight: 700;
    }

    .q-btn__content {
        .block {
            font-weight: 700;
        }
    }

    .q-tabs__content {
        .q-hoverable:hover > .q-focus-helper {
            background: inherit !important;
        }
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.btn {
    flex: 1;
    height: 8.17vmin;
    margin: 0 1vw;
    font-size: 1.2vw;
    font-weight: 700;
    border-radius: 1.33vmin;
    &__wrap {
        display: flex;
        padding: 0 1vw;
        justify-content: center;
    }
}

.question-mark {
    width: 2.1vw;
    height: 2.1vw;
    font-size: 1.5vw !important;
    align-items: flex-start;
}

.mark__list {
    li {
        font-size: 1.1vw;
        font-weight: 500;
        line-height: 1.85vw;
        word-break: keep-all;

        &:nth-of-type(n + 2) {
            margin-top: 0.67vmin;
        }
    }
}

.problem__class {
    display: flex;

    .important {
        padding-top: 0.25vh;
        width: 2.7vmin;
        height: 2.7vmin;
        margin-left: 0.3vw;
    }
}
</style>
